import _forEach from 'lodash-es/forEach.js'

const eventRegex = /^on[\w]+/

const CUSTOMS = {}

function isElementProp (element, key) {
    return key in element ||
        eventRegex.test(key) ||
        false
}

function isCustomProp (key) {
    return CUSTOMS.hasOwnProperty(key)
}

export function registerCustom (name, cb) {
    if (CUSTOMS[name]) {
        console.warn(`Custom prop function '${name}' is overwritten.`)
    }

    CUSTOMS[name] = cb
}

registerCustom('children', (element, value) => {
    if (!Array.isArray(value)) {
        throw new Error('By the children is the value required and an array')
    }

    for (const node of value) {
        appendElementToElement(element, node)
    }
})

registerCustom('class', (element, value) => {
    if (Array.isArray(value)) value = value.join(' ')
    element.setAttribute('class', value)
})

export function setAttribute (element, key, value, setAttributeAndExtOnly = false) {
    if (isCustomProp(key)) {
        CUSTOMS[key](element, value)

    } else if (!setAttributeAndExtOnly && isElementProp(element, key)) {
        element[key] = value

    } else {
        element.setAttribute(key, value)
    }
    return element
}

export function createElementNS (tagName, attributes = {}, xmlns) {
    let element = document.createElementNS(xmlns, tagName)
    setAttributes(element, attributes, true)
    return element
}

export function createFragment ({ children, html }) {
    const fragment = document.createDocumentFragment()
    if (html) fragment.innerHTML = html
    if (children) fragment.append(...children)
    return fragment
}

export function createElement (tagName, attributes = {}) {
    let element = document.createElement(tagName)
    setAttributes(element, attributes)
    return element
}

export function setAttributes (element, attributes, setAttributeAndExtOnly = false) {
    _forEach(attributes, (value, key) => setAttribute(element, key, value, setAttributeAndExtOnly))
}

export function getParentElement (element) {
    if (!element) return null
    return element.parentElement || null
}

export function getParentElementOfType (element, type = HTMLElement) {
    while ((element = getParentElement(element))) {
        if (element instanceof type) return element
    }
    return null
}

export function removeElement (element) {
    const parentElement = getParentElement(element)
    if (parentElement === null) return false
    parentElement.removeChild(element)
    return true
}

export function insertBeforeElement (beforeElement, elementToInsert) {
    const parentElement = getParentElement(beforeElement)
    if (!parentElement) return false
    parentElement.insertBefore(elementToInsert, beforeElement)
    return true
}

export function insertAfterElement (afterElement, elementToInsert) {
    if (afterElement.nextSibling) {
        return insertBeforeElement(afterElement.nextSibling, elementToInsert)
    }

    const parentElement = getParentElement(afterElement)
    if (!parentElement) return false
    appendElementToElement(parentElement, elementToInsert)
    return true
}

export function appendElementToElement (container, newElement) {
    if (!container) return false
    container.append(newElement)
    return true
}

export function appendElementToHead (newElement) {
    return appendElementToElement(document.head, newElement)
}

export function appendElementToBody (newElement) {
    return appendElementToElement(document.body, newElement)
}

export function replaceElement (oldElement, newElement) {
    const parentElement = getParentElement(oldElement)
    if (parentElement === null) return false
    parentElement.replaceChild(newElement, oldElement)
    return true
}

export function getComposedEventPath (event) {
    if (event.path) return event.path
    if (event.composedPath) return event.composedPath()

    const path = []
    let element = event.target

    do {
        path.push(element)

        if (element.tagName === 'HTML') {
            path.push(document)
            path.push(window)
            element = false
        }

        element = element.parentElement
    } while (element)

    return path
}

